import React from "react";
import style from "./ReadOnlyBanner.module.scss";

export const InfoBanner = ({ message }) => {
  return (
    <div className={style.read_only_block}>
      <div className={`alert alert-info ${style.read_only_banner}`}>
        <i className="fa fa-info-circle mr-2" />
        {message}
      </div>
    </div>
  );
};
